export const getMintEngineUrl = () => {
    const environment = process.env.REACT_APP_DEPLOYMENT_ENVIRONMENT;

    if (environment === "prod") {
        return process.env.REACT_APP_MINT_ENGINE_URL_PROD || "http://localhost:4000";
    } else {
        return process.env.REACT_APP_MINT_ENGINE_URL_STAGING || "http://localhost:4000";
    }
};
